import{useEffect as t}from"react";import{LmsSentry as e}from"./LmsSentry.js";const i=({user:r})=>(t(()=>{e.setUser({id:r?.id??"unauthorized"})},[r?.id]),null);export{i as LmsSentryUserInit};
//# sourceMappingURL=LmsSentryUserInit.js.map
